<template>
  <section class="token-invalid">
    <h2 class="label error">{{ $t('messages.other.other1') }}</h2>
    <p>Sorry, Your password reset link is invalid.</p>
    <p>
      Please go to
      <a href="javascript:;" @click="goLogin">login</a>
      page and reset your password.
    </p>
    <el-button class="mt-8" @click="goLogin">Go and Login</el-button>
    <!-- <contact-box></contact-box> -->
  </section>
</template>
<script>
import loginAndRegisterMixin from '@/mixins/loginAndRegisterMixin'
export default {
  name: 'token-invalid',
  mixins:[ loginAndRegisterMixin ],
}
</script>
<style lang="scss">
.token-invalid {
  width: 450px;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
